import React from 'react';
import { cn } from '@/utils/cn';
import TextSpan from '../Typography/TextSpan';

function HighlightText({ text, term, className = '' }) {
  if (!term)
    return (
      <TextSpan
        text={text}
        className={cn('text-sm lg:text-base text-coarse-wool', className)}
      />
    );

  const parts = text.split(new RegExp(`(${term})`, 'gi'));

  return (
    <div className="highlight-text">
      {parts.map((part, index) => (
        <TextSpan
          key={`${part}-${index}-${Date.now()}`}
          text={part}
          className={cn('text-sm lg:text-base text-coarse-wool', className, {
            'bg-pickled-ginger font-bold':
              part.toLowerCase() === term.toLowerCase(),
          })}
        />
      ))}
    </div>
  );
}

export default HighlightText;
